import styled from "styled-components";
import { Passenger } from "../../types/common.types";
import { edadEn, errorFechaNacimiento, hoyTexto } from "../../utils/edad";

// Fecha de nacimiento (o la edad, con "No sé su fecha") y sexo del pasajero en los formularios del
// vendedor (16/10/2026), igual que en el portal de aliados. Los piden las listas de control de los
// parques y las entradas se cobran por edad. Con fecha, la edad la calcula el backend.

export type DatosNacimiento = Pick<Partial<Passenger>, 'birth_date' | 'age' | 'sex'> & { sinFecha?: boolean }

const SEXOS = [{ value: 'F' as const, label: 'Femenino' }, { value: 'M' as const, label: 'Masculino' }, { value: 'O' as const, label: 'Otro' }]

// Qué falta para poder guardar, o null.
export function faltaNacimiento(d: DatosNacimiento): string | null {
    if (!d.sex) return 'Falta el sexo del pasajero.'
    if (d.sinFecha) {
        const edad = Number(d.age)
        return d.age === undefined || d.age === null || (d.age as any) === '' || !Number.isFinite(edad) || edad < 0 || edad > 110
            ? 'Falta la edad del pasajero.' : null
    }
    if (!d.birth_date) return 'Falta la fecha de nacimiento (o usa "No sé su fecha").'
    return errorFechaNacimiento(d.birth_date)
}

// Lo que se manda al backend: la fecha, o (si no se sabe) la edad.
export function datosParaEnviar(d: DatosNacimiento) {
    return d.sinFecha
        ? { age: Number(d.age), sex: d.sex }
        : { birth_date: d.birth_date, sex: d.sex }
}

export default function NacimientoYSexo({ value, onChange }: { value: DatosNacimiento, onChange: (cambio: DatosNacimiento) => void }) {
    const error = !value.sinFecha && value.birth_date ? errorFechaNacimiento(value.birth_date) : null
    const edad = !value.sinFecha && value.birth_date && !error ? edadEn(value.birth_date) : null
    return (
        <Main>
            {value.sinFecha ? (
                <label>
                    <span>Edad*</span>
                    <input type="number" min={0} max={110} placeholder="Años" aria-label="Edad*"
                        value={value.age ?? ''} onChange={e => onChange({ age: e.target.value === '' ? undefined : Number(e.target.value) })} />
                    <small>Si puedes, pide la fecha: algunos parques la exigen. <button type="button" onClick={() => onChange({ sinFecha: false })}>Ingresar fecha de nacimiento</button></small>
                </label>
            ) : (
                <label>
                    <span>Fecha de nacimiento*</span>
                    <input type="date" max={hoyTexto()} aria-label="Fecha de nacimiento*"
                        value={value.birth_date || ''} onChange={e => onChange({ birth_date: e.target.value })} />
                    <small>
                        {error ? <em>{error}</em> : edad !== null ? `${edad} ${edad === 1 ? 'año' : 'años'}` : ''}
                        {' '}<button type="button" onClick={() => onChange({ sinFecha: true })}>No sé su fecha</button>
                    </small>
                </label>
            )}
            <div className="sexo" role="group" aria-label="Sexo">
                <span>Sexo*</span>
                <div>
                    {SEXOS.map(s => (
                        <button type="button" key={s.value} aria-pressed={value.sex === s.value} className={value.sex === s.value ? 'activo' : ''}
                            onClick={() => onChange({ sex: s.value })}>{s.label}</button>
                    ))}
                </div>
            </div>
        </Main>
    )
}

const Main = styled.div`
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    label { display: flex; flex-direction: column; gap: 4px; font-size: 14px; }
    input { border: 1px solid #c9c9c9; border-radius: 8px; padding: 8px; font-size: 14px; }
    small { font-size: 12px; color: #777; }
    small em { color: #b45309; font-style: normal; }
    small button { border: none; background: none; padding: 0; color: #2c3e50; text-decoration: underline; cursor: pointer; font-size: 12px; }
    .sexo { display: flex; flex-direction: column; gap: 4px; font-size: 14px; }
    .sexo div { display: flex; gap: 6px; flex-wrap: wrap; }
    .sexo button { border: 1px solid #c9c9c9; border-radius: 999px; padding: 5px 12px; background: #fff; cursor: pointer; font-size: 13px; }
    .sexo button.activo { background: #2c3e50; border-color: #2c3e50; color: #fff; }
`
